import Manager from 'coreClasses/Manager';
import ManagerRepository from '../ManagerRepository';

import {cloneObject} from 'coreUtils/utils';
import {isServer} from 'coreUtils/utils';

import {TStaticCache, ISetContextPayload, TSiteStaticCache} from './IStaticCache';

/**
 * Represents StaticCacheMgr
 */
class StaticCacheMgr extends Manager {
	private _staticCache: TStaticCache;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {Object} staticCache - static cache object
	 */
	constructor(managerRepository: ManagerRepository, staticCache: TStaticCache) {
		super(managerRepository);

		if (isServer) {
			this._staticCache = cloneObject(staticCache);
		}
	}

	/**
	 * Returns the entire staticCache object for the current site
	 * @returns {Object} staticCache
	 */
	get staticCache(): TSiteStaticCache {
		return this._staticCache?.[this.managerRepository.getSfccAPI().getSiteId()] || null;
	}

	/**
	 * Returns countries response from static cache
	 * @returns {Object} countries
	 */
	public getCountries(): object {
		if (this.managerRepository.getContentMgr().isPreviewMode()) {
			return null;
		}

		return this.staticCache?.countries;
	}

	/**
	 * Returns configurations response from static cache
	 * @returns {Object} configurations
	 */
	public getConfigurations(): object {
		if (this.managerRepository.getContentMgr().isPreviewMode()) {
			return null;
		}

		return this.staticCache?.configurations;
	}

	/**
	 * Returns locales response from static cache
	 * @returns {Object} locales
	 */
	public getLocales(): object {
		if (this.managerRepository.getContentMgr().isPreviewMode()) {
			return null;
		}

		return this.staticCache?.locales;
	}

	/**
	 * Returns setContext response from static cache
	 * @param {Object} payload setContext payload
	 * @returns {Object} setContext response
	 */
	public setContext(payload: ISetContextPayload): object {
		if (this.managerRepository.getContentMgr().isPreviewMode()) {
			return null;
		}

		const country = payload?.customQualifiers?.shippingCountry;

		return country && this.staticCache?.contextSet?.[country];
	}
}

export default StaticCacheMgr;
